import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MaterialsModule } from '@library/common/materials';

import { TrackerLineComponent, TrackerTooltipComponent } from './tracker-line/tracker-line.component';

@NgModule({
   declarations: [
      TrackerLineComponent,
      TrackerTooltipComponent,
   ],
   imports: [
      CommonModule,
      RouterModule,

      MaterialsModule,
   ],
   exports: [
      TrackerLineComponent,
      TrackerTooltipComponent,
   ],
})
export class QuotationModule { }
